<template>
  <div class="breadcrumb">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <template v-for="(item, i) in data">
        <el-breadcrumb-item v-if="isLinkDisabled(item, i)" :key="i">{{item.name}}</el-breadcrumb-item>
        <el-breadcrumb-item v-else :key="i" :to="{path: item.path}">{{item.name}}</el-breadcrumb-item>
      </template>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumb',
  data () {
    return {
      data: []
    }
  },
  created () {
    this.initBreadcrumbMenus()
  },
  watch: {
    $route () {
      this.initBreadcrumbMenus()
    }
  },
  methods: {
    initBreadcrumbMenus () {
      const path = this.$route.path
      if (path === '/home') {
        this.data = [{ path: '/home', name: '首页' }]
        return
      }

      const navigation = {
        '/p': [null, '游戏管理'],
        '/c/cl': ['渠道接入', '渠道列表'],
        '/pl': ['渠道接入', '平台规划'],
        '/ct': ['渠道接入', '渠道类型'],
        '/l': ['渠道接入', 'Visitor逻辑'],
        '/n': ['渠道接入', '同步参数'],
        '/nacos': ['渠道接入', '重载NACOS'],
        '/xs/args/game': ['登录支付', 'XS游戏'],
        '/xs/args/channel': ['登录支付', 'XS渠道'],
        '/xs/args/logic': ['登录支付', 'XS逻辑'],
        '/xs/args/pay': ['登录支付', '支付Args'],
        '/xs/telecom/auth': ['登录支付', '电信认证'],
        '/mch/group': ['商户配置', '商户组'],
        '/mch/wx': ['商户配置', '微信商户'],
        '/mch/ali': ['商户配置', '支付宝商户'],
        '/mch/apple': ['商户配置', 'Apple应用'],
        '/ext/config/game': ['扩展配置', 'Ext游戏'],
        '/ext/config/channel': ['扩展配置', 'Ext渠道'],
        '/ext/config/template': ['扩展配置', 'Ext模板'],
        '/holiday': ['环境配置', '节假日'],
        '/menu': ['环境配置', '卸载菜单'],
        '/area': ['环境配置', '网关域名'],
        '/ufo/group': ['环境配置', 'UFO分组'],
        '/pkg': ['环境配置', '证书配置'],
        '/ufw': ['UFW', '节点内存'],
        '/ufw/white': ['UFW', '白名单'],
        '/ufw/black': ['UFW', '黑名单'],
        '/advert/app': ['广告变现', '广告应用'],
        '/advert/channel': ['广告变现', '广告渠道'],
        '/company': ['公司主体', '公司管理'],
        '/organize': ['公司主体', '组织管理'],
        '/wiki/app': ['其他', '应用分配'],
        '/wiki/vpc': ['其他', 'VPC规划']
      }

      const current = navigation[path]
      if (path === '/c/detail') {
        this.data = [
          { path: '/home', name: '首页' },
          { name: '渠道接入', disabled: true },
          { path: '/c/cl', name: '渠道列表' },
          { name: '渠道详情', disabled: true }
        ]
        return
      }
      if (current) {
        this.data = [{ path: '/home', name: '首页' }]
        if (current[0]) this.data.push({ name: current[0], disabled: true })
        this.data.push({ path, name: current[1] })
        return
      }

      const menus = this.$route.matched.filter(item => !item.hidden && item.name)
      this.data = [{ path: '/home', name: '首页' }].concat(menus)
    },
    isHome (route) {
      if (!route || !route.name) {
        return false
      }
      const path = route.path
      return path && path.trim().toLocaleLowerCase() === '/home'.toLocaleLowerCase()
    },
    isLinkDisabled (item, i) {
      if (!item) return true
      if (item.disabled) return true
      if (item.meta && item.meta.breadcrumbLinkDisable) {
        return true
      }
      if (item.path === '/home') {
        return false
      }
      if (i < this.data.length - 1) {
        const matchedRoute = this.$router.options.routes.find(r => r.path === item.path || (r.children && r.children.some(c => c.path === item.path)))
        if (matchedRoute && (matchedRoute.subMenu || (matchedRoute.children && matchedRoute.children.length > 0))) {
          return true
        }
        if (item.subMenu || (item.children && item.children.length > 0)) {
          return true
        }
      }
      return false
    }
  }
}
</script>

<style scoped>
.breadcrumb {
  display: flex;
  align-items: center;
}
</style>
